/* global axios */
import ApiClient from './ApiClient';

class KanbanAPI extends ApiClient {
  constructor() {
    super('kanban', { accountScoped: true });
  }

  getBoard(params = {}) {
    return axios.get(this.url, { params });
  }

  getBoardByKey(boardKey, params = {}) {
    return axios.get(`${this.url}/board/${boardKey}`, { params });
  }

  moveCard(conversationId, targetStage, position = null, boardKey = null) {
    return axios.post(`${this.url}/move`, {
      conversation_id: conversationId,
      target_stage: targetStage,
      position,
      board_key: boardKey,
    });
  }

  reorderCards(cards, boardKey = null) {
    return axios.patch(`${this.url}/reorder`, { cards, board_key: boardKey });
  }

  getStages(boardKey = null) {
    const params = boardKey ? { board_key: boardKey } : {};
    return axios.get(`${this.url}/stages`, { params });
  }

  updateStages(stages, boardKey = null) {
    const params = boardKey ? { board_key: boardKey } : {};
    return axios.patch(`${this.url}/stages`, { stages, ...params });
  }

  getLaneCards(params = {}) {
    const stage = encodeURIComponent(params.stage);
    const queryParams = { ...params };
    delete queryParams.stage;
    return axios.get(`${this.url}/lanes/${stage}/cards`, {
      params: queryParams,
    });
  }
}

export default new KanbanAPI();
